import React from 'react';
import darkTheme from "../theme/darkBaseTheme";
import withRipple from "../hocs/withRipple";
import { RadioButton, Input, Label, Text } from "./styles";












const Button = withRipple(
RadioButton);


export const RadioBox = ({
  id,
  name,
  label,
  value,
  isChecked = false,
  onChange,
  className }) => /*#__PURE__*/

React.createElement(Button, {
  type: "button",
  role: "button",
  className: className,
  isChecked: isChecked,
  rippleColor: darkTheme.colors['Level 2'] }, /*#__PURE__*/

React.createElement(Label, { htmlFor: id }, /*#__PURE__*/
React.createElement(Input, {
  id: id,
  type: "radio",
  role: "radio",
  "aria-checked": isChecked,
  name: name,
  value: value,
  checked: isChecked,
  onChange: onChange }), /*#__PURE__*/

React.createElement(Text, null, label)));